"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewPaymentSplit_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var NewPaymentSplit_Factory = /** @class */ (function () {
    function NewPaymentSplit_Factory() {
    }
    NewPaymentSplit_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Amount: model.Amount,
            PatientId: model.PatientId,
            PaymentPlanScheduleId: model.PaymentPlanScheduleId,
        };
        return result;
    };
    NewPaymentSplit_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Amount: model.Amount,
            PatientId: model.PatientId,
            PaymentPlanScheduleId: model.PaymentPlanScheduleId,
        };
        return result;
    };
    return NewPaymentSplit_Factory;
}());
exports.NewPaymentSplit_Factory = NewPaymentSplit_Factory;
